// import Frcst from './05/Frcst';
// import RoutMain from './10/RoutMain';
// import Fcst from './12/Fcst';
import { RecoilRoot } from 'recoil';
//import DivMains from './14/DivMains';
import './App.css';
import Login from './15/Login';
// import Mycom from './03/Mycom'
// import MycomN from './03/MycomN'
// import MyDiv from './03/MyDiv'
// import Clock from './01/Clock';
// import Lotto from './02/Lotto'/;
// import BoxOffice from './04/BoxOffice';
// import Taccident from './06/Taccident';
// import Gallery from './08/Gallery';
// import Busan from './09/Busan';


function App() {
  return (
    // <Clock />
    // <Lotto/>
    // <Mycom />
    // <MyDiv />
    // <BoxOffice />
    // <Frcst />
    // <Taccident />
    // <Gallery />
    // <Busan />
    // <RoutMain />
    // <Fcst />
    //<RecoilRoot>
      //<DivMains />
    //</RecoilRoot>
    <RecoilRoot>
      <Login />
    </RecoilRoot>
  );
}

export default App;
